import React from "react";
import { Grid, Paper } from "@mui/material";
import usePrimaryColor from "../../hooks/usePrimaryColor";

export default function PaperSection({ children }) {
  return (
    <Grid item xs={12}>
      <Paper
        sx={{
          p: 2,
          borderBottom: `2px solid ${usePrimaryColor()}`,
          boxShadow: "none",
        }}
      >
        {children}
      </Paper>
    </Grid>
  );
}
